import { cva } from 'class-variance-authority'

export const progressRootVariants = cva('relative h-2 w-full overflow-hidden rounded-full bg-primary/20')

export const progressIndicatorVariants = cva('h-full w-full flex-1 bg-primary transition-all')
